import { GENERATEATTACHEMENT_SUCCESS, GENERATEATTACHEMENT_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const generateAttachementReducer = (state = initialState, action) => {
    switch (action.type) {
        case GENERATEATTACHEMENT_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GENERATEATTACHEMENT_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: [],
            };
        default:
            break;
    }

    return state;
};

export default generateAttachementReducer;
